import gql from 'graphql-tag';

export const FindCustomerFields = gql`
	fragment FindCustomerFields on CustomerSearchResult {
		id
		firstName
		lastName
		email
		orderCount
		lastOrderDate
		billingAddress {
			address
			address2
			city
			state {
				name
			}
			zipCode
		}
	}
`;

export const FIND_CUSTOMER = gql`
	${FindCustomerFields}
	query FindCustomer($input: FindCustomerInput!) {
		findCustomer(input: $input) {
			accounts {
				...FindCustomerFields
			}
			guests {
				...FindCustomerFields
			}
		}
	}
`;
